import { Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { MockBillingDashboard } from "../../../Public/Landingpages/Components/MockScreens";

const Billing = () => {
  return (
    <>
      <div className="lp-section-alt">
        <Container>
          <Row className="align-items-center" style={{ paddingTop: "4.5rem", paddingBottom: "4.5rem", position: "relative" }}>
            <Col className="yellowdotWelcome" />
            <Col className="greendotWelcome" />
            <Col md={6} sm={12} style={{ marginBottom: "1.5rem" }}>
              <MockBillingDashboard />
            </Col>
            <Col md={1} />
            <Col md={5} sm={12}>
              <span className="blueSubheaderTop">Billing</span>
              <div className="landingpageHeader" style={{ fontWeight: "400", lineHeight: "110%", marginTop: "0.5rem" }}>
                Elevate your Business with our Billing Solution
              </div>
              <p className="landingpageDescriptions" style={{ marginBottom: "1.5rem" }}>
                Simplify your incoming and outgoing bills with our automated
                billing system. Keep track of payments, due dates, and financial
                summaries without the hassle.
              </p>
              <div className="lp-feature-card">
                <div className="lp-feature-card-icon">
                  <FontAwesomeIcon icon={faArrowDown} />
                </div>
                <span className="lp-feature-card-label">Incoming Billing</span>
              </div>
              <div className="lp-feature-card">
                <div className="lp-feature-card-icon">
                  <FontAwesomeIcon icon={faArrowUp} />
                </div>
                <span className="lp-feature-card-label">Outgoing Billing</span>
              </div>
              <p style={{ fontStyle: "italic", color: "#888", fontSize: "0.875rem", marginTop: "1rem" }}>
                Coming soon: AI-powered data extraction from bills
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Billing;
